var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6,17v1.3h-9.1V17H19.6z M12.8,23.5l0.1,0H13c0.5,0,0.8,0.2,1.2,0.5c0.6,0.5,1.4,0.8,2.2,0.8c1.6,0,2.5-1.4,2.9-2.5 L18.1,22c-0.2,0.6-0.7,1.5-1.6,1.5c-0.6,0-1.1-0.2-1.5-0.6c-0.5-0.4-1.2-0.7-1.9-0.7c-0.8,0.1-1.6,0.5-2.2,1.1l1,0.9 C12.1,23.9,12.4,23.7,12.8,23.5z M10.4,11.7V13h9.1v-1.3H10.4z M26.1,7.5V30H3.9V3.3C3.9,1.5,5.4,0,7.2,0h11.4 c1.2,0,2.4,0.5,3.2,1.3l2.9,2.9C25.6,5.1,26.1,6.3,26.1,7.5z M24.8,7.8h-6.5V1.3H7.2c-1.1,0-2,0.9-2,2v25.4h19.6V7.8z M24.8,6.5 l-0.8-1c-0.1-0.1-0.2-0.2-0.2-0.3l-3-3c-0.1-0.1-0.2-0.2-0.3-0.2l-1-0.8v5.3H24.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.7a160a7620513d5a7d2e15454276b05b.svg";
export { ForwardRef as ReactComponent };